import request from './request';

export function follow(followUserId) {
  return request.post('/api/follow/follow', { follow_user_id: followUserId });
}
export function unfollow(followUserId) {
  return request.post('/api/follow/unfollow', { follow_user_id: followUserId });
}
export function getFollowStatus(followUserId) {
  return request.get('/api/follow/status', { params: { follow_user_id: followUserId } });
}
export function getFollowList(params) {
  return request.get('/api/follow/followList', { params });
}
export function getFansList(params) {
  return request.get('/api/follow/fansList', { params });
}
export function getFollowCount() {
  return request.get('/api/follow/count');
}
